import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import AppShell from "@/components/layout/AppShell";
import { OfflineBanner } from "@/components/common/OfflineBanner";
import Login from "@/pages/Login";
import CommandCenter from "@/pages/CommandCenter";
import Residents from "@/pages/Residents";
import ResidentProfile from "@/pages/ResidentProfile";
import Medications from "@/pages/Medications";
import Compliance from "@/pages/Compliance";
import Staffing from "@/pages/Staffing";
import Staff from "@/pages/Staff";
import Incidents from "@/pages/Incidents";
import Activities from "@/pages/Activities";
import Alerts from "@/pages/Alerts";
import Tasks from "@/pages/Tasks";
import AIInsights from "@/pages/AIInsights";
import Documents from "@/pages/Documents";
import Families from "@/pages/Families";
import Training from "@/pages/Training";
import HealthIntelligence from "@/pages/HealthIntelligence";
import Fleet from "@/pages/Fleet";
import Assets from "@/pages/Assets";
import Finance from "@/pages/Finance";
import Maintenance from "@/pages/Maintenance";
import InsightBridge from "@/pages/InsightBridge";
import Reports from "@/pages/Reports";
import Administration from "@/pages/Administration";
import Programs from "@/pages/Programs";
import Messages from "@/pages/Messages";
import ModulePlaceholder from "@/pages/ModulePlaceholder";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return <div className="flex h-screen items-center justify-center bg-background text-muted-foreground">Loading CAREIQ…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
          <OfflineBanner />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Protected><AppShell /></Protected>}>
              <Route index element={<CommandCenter />} />
              <Route path="ai-insights" element={<AIInsights />} />
              <Route path="residents" element={<Residents />} />
              <Route path="residents/:id" element={<ResidentProfile />} />
              <Route path="health" element={<HealthIntelligence />} />
              <Route path="medications" element={<Medications />} />
              <Route path="compliance" element={<Compliance />} />
              <Route path="insightbridge" element={<InsightBridge />} />
              <Route path="staffing" element={<Staffing />} />
              <Route path="staff" element={<Staff />} />
              <Route path="incidents" element={<Incidents />} />
              <Route path="activities" element={<Activities />} />
              <Route path="alerts" element={<Alerts />} />
              <Route path="tasks" element={<Tasks />} />
              <Route path="families" element={<Families />} />
              <Route path="training" element={<Training />} />
              <Route path="programs" element={<Programs />} />
              <Route path="reports" element={<Reports />} />
              <Route path="documents" element={<Documents />} />
              <Route path="fleet" element={<Fleet />} />
              <Route path="finance" element={<Finance />} />
              <Route path="assets" element={<Assets />} />
              <Route path="maintenance" element={<Maintenance />} />
              <Route path="messages" element={<Messages />} />
              <Route path="settings" element={<Administration />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
